export var CustomUserImportExposeGroup;
(function (CustomUserImportExposeGroup) {
    CustomUserImportExposeGroup["MODEL"] = "model";
    CustomUserImportExposeGroup["READ"] = "read";
})(CustomUserImportExposeGroup || (CustomUserImportExposeGroup = {}));
export const UserImportExposeGroup = Object.freeze({ ...CustomUserImportExposeGroup });
//# sourceMappingURL=user-import-expose-group.js.map